import React, {Component} from 'react';
import PropTypes from 'prop-types';
import * as R from 'ramda';
import {connect} from 'react-redux';

import SmartQuestion from 'js/execution/v2/panels/smart_questions_panel/shared_proptypes/smart_question';
import * as CampaignHelper from 'js/common/campaign_helper';
import SmartQuestionHelper from 'js/common/smart_question_helper';
import Loader from 'react-loader';

import {ENUMS} from 'js/common';

// Redux
import {
    doGrantExtension,
    doUpdateCurrentInviteState,
    doWipeCampaignInvites
} from 'js/creator/ducks/invites';

// Components
import CampaignQualificationContainer from 'js/components/campaign_qualification_container';
import SmartQuestionHeader from './smart_question_header';
import CreatorCampaignBrief from '../../components/creator_campaign_brief';
import {getAuth0Storage} from 'js/auth0_storage';

/**
 * @todo this needs to be turned into a set of components and sub-components
 * continuing to add render will make this untenable
 * @export
 * @class CampaignGuidelines
 * @extends {Component}
 */
export class CampaignGuidelines extends Component {
    static propTypes = {
        brand: PropTypes.shape({
            logo_url: PropTypes.string,
            name: PropTypes.string
        }),
        campaign: PropTypes.shape({
            id: PropTypes.number,
            name: PropTypes.string,
            type: PropTypes.string,
            video_orientation: PropTypes.string,
            sample_post_url: PropTypes.string,
            short_description: PropTypes.string,
            creator_expense_amount: PropTypes.number,
            smart_questions: PropTypes.arrayOf(SmartQuestion),
            hide_guideline_details: PropTypes.bool
        }),
        children: PropTypes.element,
        user: PropTypes.shape({
            profile_picture_url: PropTypes.string
        }),
        extension_metadata: PropTypes.shape({
            extension_end_ts: PropTypes.number.isRequired,
            granted_extension_end_ts: PropTypes.number.isRequired,
            has_extension: PropTypes.bool.isRequired,
            within_extension_window: PropTypes.bool.isRequired,
            is_expired: PropTypes.bool.isRequired
        }),
        /** The invite Id */
        id: PropTypes.string,
        is_paid: PropTypes.bool,
        username: PropTypes.string,
        hashtags: PropTypes.array,
        screen_names: PropTypes.array,
        guidelines: PropTypes.array,
        smart_question_answer_result: PropTypes.bool,
        doUpdateCurrentInviteState: PropTypes.func.isRequired,
        doWipeCampaignInvites: PropTypes.func.isRequired,
        status: PropTypes.number.isRequired,
        flight_end: PropTypes.number.isRequired,
        invite_sent_at: PropTypes.string
    };

    static defaultProps = {
        campaign: {},
        brand: {},
        user: {},
        override: {},
        extension_metadata: {},
        hashtags: [],
        screen_names: [],
        guidelines: [],
        showInitialGuideline: false
    };

    constructor(props) {
        super(props);

        this.state = {
            zoidIframeHeight: undefined,
            isLegacyBriefFallbackVisible: false,
            inferredSmartQuestionState: SmartQuestionHelper.answerInferrableQuestions(
                props.user,
                R.path(['campaign', 'smart_questions'], props)
            ),
            enteredAddressInfoThisTime: false,
            isLoadingEmbeddedBrief: true
        };
    }

    isInviteAccepted = () => {
        const {status} = this.props;

        return R.contains(status, [ENUMS.InviteStatus.ACCEPTED, ENUMS.InviteStatus.APPROVED]);
    };

    handleSmartQuestionSubmission = data => {
        this.props.doWipeCampaignInvites();
        this.props.doUpdateCurrentInviteState({
            smart_question_answer_result: R.path(['payload', 'data', 'is_success'], data)
        });
    };

    handleShippingInfoEntered = () => {
        this.setState({enteredAddressInfoThisTime: true});
    };

    renderSmartQuestionHeader = () => {
        const {campaign, smart_question_answer_result} = this.props;
        const {inferredSmartQuestionState, enteredAddressInfoThisTime} = this.state;

        const {smart_questions} = campaign;

        const hasSmartQuestions = R.not(R.isEmpty(smart_questions));

        if (this.isInviteAccepted()) {
            return null;
        }

        if (hasSmartQuestions) {
            if (inferredSmartQuestionState === false) {
                return <SmartQuestionHeader type={false} />;
            }

            const isShippingProduct = CampaignHelper.isShippingProduct(campaign);
            const hasSmartQuestionResult = smart_question_answer_result !== null;

            let headerType = null;

            if (isShippingProduct) {
                headerType = enteredAddressInfoThisTime || headerType;
            }

            if (hasSmartQuestionResult) {
                headerType = smart_question_answer_result;
            }

            return <SmartQuestionHeader type={headerType} />;
        }

        if (CampaignHelper.isShippingProduct(campaign)) {
            return <SmartQuestionHeader type={enteredAddressInfoThisTime || null} />;
        }
    };

    onBriefStateReady = isBriefStateReady => {
        if (isBriefStateReady && this.state.isLoadingEmbeddedBrief) {
            this.setState({
                isLoadingEmbeddedBrief: false
            });
        }
    };

    onZoidIframeResize = windowSize => {
        // This function gets passed to the source iframe component and can respond properly when the size of the content in the iframe changes.
        // This is important for proper scrolling behavior for the iframe on mobile devices
        if (windowSize.height !== this.state.zoidIframeHeight) {
            this.setState({
                zoidIframeHeight: windowSize.height
            });
        }
    };

    renderEmbeddedCampaignBrief = () => {
        const {extension_metadata: extensionMetadata} = this.props;
        const submissionWindowEndUnix = extensionMetadata.has_extension
            ? extensionMetadata.granted_extension_end_ts
            : this.props.flight_end;

        if (R.equals(status, ENUMS.InviteStatus.REJECTED)) {
            return null;
        }

        return (
            <div
                className={'snclient-campaign-brief-embedded'}
                style={{
                    minHeight: `400px`,
                    height: `${this.state.zoidIframeHeight}px`
                }}
            >
                {this.state.isLoadingEmbeddedBrief ? (
                    <div>
                        <Loader loaded={!this.state.isLoadingEmbeddedBrief}></Loader>
                    </div>
                ) : null}
                {this.props.campaign.id && !this.state.isLegacyBriefFallbackVisible && (
                    <CreatorCampaignBrief
                        application={this.props.application}
                        creatorPayount={this.props.total_payout_amount}
                        flightStartDate={this.props.flight_start}
                        flightEndDate={submissionWindowEndUnix}
                        campaignId={this.props.campaign.id.toString()}
                        onBriefDataReadyChange={this.onBriefStateReady}
                        onContentResize={this.onZoidIframeResize} // required height handling to properly work on mobile devices.
                    />
                )}
            </div>
        );
    };

    render() {
        const {campaign, children, id: inviteId, smart_question_answer_result} = this.props;
        const {smart_questions, hide_guideline_details} = campaign;
        const {inferredSmartQuestionState} = this.state;

        const isShippingProduct = CampaignHelper.isShippingProduct(campaign);

        return (
            <div>
                {this.renderSmartQuestionHeader()}

                <CampaignQualificationContainer
                    inviteId={inviteId}
                    campaign={campaign}
                    smartQuestionProps={{
                        questions: smart_questions,
                        currentResult: smart_question_answer_result,
                        handleSubmit: this.handleSmartQuestionSubmission,
                        autoSubmit: inferredSmartQuestionState
                    }}
                    isInviteAccepted={this.isInviteAccepted()}
                    campaignIsShippingProduct={isShippingProduct}
                    handleShippingInfoEntered={this.handleShippingInfoEntered}
                >
                    {!hide_guideline_details && this.renderEmbeddedCampaignBrief()}

                    {children}
                </CampaignQualificationContainer>
            </div>
        );
    }
}

export default connect(R.pickAll([]), {
    doGrantExtension,
    doUpdateCurrentInviteState,
    doWipeCampaignInvites
})(CampaignGuidelines);



// WEBPACK FOOTER //
// ./components/campaign_guidelines/index.js